import type { ReactNode } from 'react';

import { Breadcrumbs } from '@/components/breadcrumbs';

/**
 * Page heading. Mirrors the walkthrough's `.crumbs` / `<h1>` / `.sub` block so
 * every screen opens the same way the stakeholder demo did.
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        {/* The trail comes from the ROUTE, so no page can pass a wrong one.
            `eyebrow` remains for the two screens whose crumb is not navigation —
            the harness and a result — and is used only where no trail exists. */}
        <Breadcrumbs fallback={eyebrow} />
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-muted-foreground mt-1 text-sm">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
